import React from 'react';
import { Image as BuilderImage } from '@builder.io/react';
import { getImage, GatsbyImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';

import { FontAwesomeIcon } from '../../libs/fonts'

import Chip from '../Chip/Chip';
import { locationBoth, locationSanFrancisco, locationLondon } from './locations';

const SpeakerCard = ({ speaker, placeholder, showLocationChip, chipColor }) => {
  if (!speaker) {
    return <></>;
  }
  return (
    <div className='col-lg-4 col-md-6'>
      <div className='team-item'>
        <div className='team-inner-wrap'>
          <div className='images-wrap' style={{ position: 'relative', maxHeight: 290 }}>
            <>
              {speaker.localFile ? (
                <GatsbyImage image={getImage(speaker.localFile)} alt={speaker.name} />
              ) : (
                <BuilderImage
                  image={placeholder}
                  alt={`Placeholder image for ${speaker.name}'s avatar`}
                />
              )}
              {/* {speaker.isRemote && (
              <Chip type='remote' position='absolute' />
            )} */}
              {showLocationChip && speaker.location && (
                speaker.location === locationBoth ? (
                  <Chip position='absolute' userColor={chipColor}>{locationLondon}/{locationSanFrancisco}</Chip>
                ) : (
                  <Chip position='absolute' userColor={chipColor}>{speaker.location}</Chip>
              ))}
            </>
          </div>
          <div className='team-content' style={{ minHeight: 60 }}>
            <h3 className='title-name'>
              <Link to={speaker.path}>{speaker.name}</Link>
            </h3>
            <div className='team-title'>{speaker.company || `\u00A0`}</div>
            <ul className='social-icons'>
              {speaker.linkedin ? (
                <li>
                  <a href={speaker.linkedin}>
                    <FontAwesomeIcon icon={`fa-brands fa-linkedin`} style={{ color: 'black' }} />
                    <span style={{ display: 'none' }}>LinkedIn link</span>
                  </a>
                </li>
              ) : `\u00A0`}
              {speaker.twitter && (
                <li>
                  <a href={`https://twitter.com/${speaker.twitter}`}>
                    <FontAwesomeIcon icon={`fa-brands fa-twitter`} style={{ color: 'black' }} />
                    <span style={{ display: 'none' }}>X link</span>
                  </a>
                </li>
              )}
              {speaker.mastodon && (
                <li>
                <a href={`https://mastodon.social/${speaker.mastodon}`}>
                  <FontAwesomeIcon icon={`fa-brands fa-mastodon`} style={{ color: 'black' }} />
                  <span style={{ display: 'none' }}>Mastodon link</span>
                </a>
              </li>
              )}
              {speaker.websiteUrl && (
                <li>
                  <a href={speaker.websiteUrl}>
                    <FontAwesomeIcon icon={`fa-solid fa-link`} style={{ color: 'black' }} />
                    <span style={{ display: 'none' }}>Website link</span>
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpeakerCard;
